<template>
    <!--弹窗-->
    <el-dialog
        width="80%"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" :rules="rules" :inline="true" size="mini">
            <div class="subTitle">基础信息</div>
            <div class="top1">
                <div class="top1Left">
                    <el-form-item label="">
                        <img style="width:90px;height:90px;" :src="formData.img_url" v-if="formData.img_url"/>
                    </el-form-item>
                </div>
                <div class="top1Right">

                    <div class="itemInfo">
                        <div class="itemTitle">ID:</div>
                        <div class="itemContent">{{ formData.id }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">评分:</div>
                        <div class="itemContent">{{ formData.rating }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">类目:</div>
                        <div class="itemContent" @click="showInfo('类目', formData.category)">{{
                            formData.category
                            }}
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">ASIN:</div>
                        <div class="itemContent">
                            <icon-svg :icon-class="formData.state.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;" v-if="formData.state"></icon-svg>
                            {{ formData.asin }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">评论数:</div>
                        <div class="itemContent">{{ formData.rating_count }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">类目树:</div>
                        <div class="itemContent" @click="showInfo('类目树', formData.category_tree)">{{ formData.category_tree }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">销售国家:</div>
                        <div class="itemContent" v-if="formData.category_state">
                            <icon-svg :icon-class="formData.category_state.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">品牌:</div>
                        <div class="itemContent" @click="showInfo('品牌', formData.brand)">{{ formData.brand }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">创建时间:</div>
                        <div class="itemContent">{{ formData.create_time }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">父ASIN:</div>
                        <div class="itemContent">{{ formData.parent_asin }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">上架时间:</div>
                        <div class="itemContent">{{ formData.listed_since }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">创建类型:</div>
                        <div class="itemContent">{{ formData.manager_cost_analysis_task_id == null ? '自建' : '管理员创建' }}</div>
                    </div>


                </div>
            </div>
            <hr>
            <div class="subTitle">调整参数</div>
            <div class="top2">
                <el-form-item label="标题：">
                    <el-input style="width: 600px;" clearable v-model="formData.title" placeholder="请输入标题"
                              size="mini"></el-input>
                </el-form-item>
                <el-form-item class="sku-data-form-item">
                    <div class="sku-item">
                        <el-form-item>
                            <el-button type="primary" size="mini" @click="getSkuByTitle(formData.title)">SKU数据</el-button>
                        </el-form-item>
                        <el-form-item label="SKU:">
                            <el-input style="width: 280px;" clearable v-model="formData.sku" placeholder="SKU" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="颜色:">
                            <el-input style="width: 100px;" clearable v-model="formData.color" placeholder="颜色" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="尺码:">
                            <el-input style="width: 100px;" clearable v-model="formData.size" placeholder="尺码" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="件装:">
                            <el-input style="width: 100px;" clearable v-model="formData.box_quantity" placeholder="件装" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="warning" size="mini" @click="checkSku">SKU检测</el-button>
                        </el-form-item>
                    </div>
                </el-form-item>
                <br/>
                <div class="line2">
                    <el-form-item label="销售价格：">
                        <el-input-number
                            v-model="formData.selling_price"
                            style="width: 150px;"
                            :min="0.00"
                            :step="0.01"
                            size="mini"
                            placeholder="请输入销售价格"
                        >
                        </el-input-number>
                    </el-form-item>

                    <el-form-item label="">
                        <el-checkbox v-model="formData.confirm_selling_price">确认销售价格</el-checkbox>
                    </el-form-item>

                    <el-form-item label="退货率：">
                        <el-input v-model="formData.refund_rate" style="width: 150px;margin-right:20px;" size="mini"
                                  placeholder="请输入退货率">
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="是否季节性：">
                        <el-checkbox v-model="formData.is_seasonality">是否季节性</el-checkbox>
                    </el-form-item>

                    <el-form-item label="季节：" class="query-form-item">
                        <el-select v-model="formData.season" placeholder="请选择" size="mini" filterable clearable>
                            <el-option :label="item.label" :value="item.value" v-for="item in $common.seasonArrNoDefault"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="指定运输模式：" class="query-form-item">
                        <el-select v-model="formData.set_deliver_mode" placeholder="请选择" size="mini" filterable>
                            <el-option :label="item.label == '全部' ? '默认' : item.label" :value="item.value"
                                       v-for="item in $common.deliverModeArr"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="标品类型：" class="query-form-item">
                        <el-select v-model="formData.standard_product_type" placeholder="标品类型" size="mini">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未录入" :value="-1"></el-option>
                            <el-option :label="item.name" :value="item.value"
                                       v-for="item in standardProductTypeArr"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="选品原则：" class="query-form-item">
                        <el-select v-model="formData.selection_principle" placeholder="选品原则" size="mini">
                            <el-option label="全部" value=""></el-option>
                            <el-option :label="item.name" :value="item.value"
                                       v-for="item in selectionPrincipleList"></el-option>
                        </el-select>
                    </el-form-item>

                </div>
                <div class="line3">
                    <el-form-item label="规格：">

                    </el-form-item>
                    <el-form-item label="长(cm)：">
                        <el-input style="width: 150px;" clearable v-model="formData.long"
                                  placeholder="请输入规格-长(cm)" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="宽(cm)：">
                        <el-input style="width: 150px;" clearable v-model="formData.wide"
                                  placeholder="请输入规格-宽(cm)" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="高(cm)：">
                        <el-input style="width: 150px;" clearable v-model="formData.height"
                                  placeholder="请输入规格-高(cm)" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="重(g)：">
                        <el-input style="width: 150px;" clearable v-model="formData.weight"
                                  placeholder="请输入规格-重(g)" size="mini"></el-input>
                    </el-form-item>
                </div>
            </div>
            <hr>
            <div class="subTitle">1688产品</div>
            <div class="top3">
                <div class="top3Left">
                    <div v-if="!formData.ali_pic_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="formData.ali_pic_url" v-if="formData.ali_pic_url"/>
                    <br/>
                    <el-button @click="choose1688" size="mini" type="primary">其他</el-button>
                </div>
                <div class="top3Right">
                    <el-form-item label="图片路径：">
                        <el-input style="width: 200px;" clearable v-model="formData.ali_pic_url"
                                  placeholder="请输入1688产品图片Url" size="mini"></el-input>
                    </el-form-item>

                    <el-form-item label="标题：">
                        <el-input style="width: 200px;" clearable v-model="formData.ali_title"
                                  placeholder="请输入1688产品标题" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="产品价格：">
                        <el-input-number
                            v-model="formData.ali_factory_price"
                            style="width: 150px;"
                            :min="0.00"
                            :step="0.01"
                            size="mini"
                            placeholder="请输入1688产品价格"
                        >
                        </el-input-number>
                    </el-form-item>
                    <el-form-item label="">
                        <el-checkbox v-model="formData.confirm_ali_message">确认链接</el-checkbox>
                    </el-form-item>
                    <el-form-item label="产品链接：">
                        <el-input style="width: 200px;" clearable v-model="formData.ali_href_link"
                                  placeholder="请输入1688产品链接" size="mini"></el-input>
                        <el-button v-show="formData.ali_href_link" type="primary" size="mini"
                                   @click="jumpUrl(formData.ali_href_link)">跳转
                        </el-button>
                    </el-form-item>
                </div>
            </div>
            <hr>
            <div class="subTitle">成本结算</div>
            <div class="top4">
                <div class="line1">
                    <div class="itemInfo">
                        <div class="itemTitle">运输模式:</div>
                        <div class="itemContent">{{ formData.deliver_mode }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">运费:</div>
                        <div class="itemContent">{{ formData.freight }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">运费单价/kg:</div>
                        <div class="itemContent">{{ formData.freight_unit_price }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">运费差:</div>
                        <div class="itemContent">{{ formData.freight_difference }}</div>
                    </div>

                </div>
                <div class="line2">
                    <div class="itemInfo">
                        <div class="itemTitle">平台佣金:</div>
                        <div class="itemContent">{{ formData.platform_commission }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">亚马逊物流配送费:</div>
                        <div class="itemContent">{{ formData.delivery_charge }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">退货费用:</div>
                        <div class="itemContent">{{ formData.refund_charge }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">Vat税费:</div>
                        <div class="itemContent">{{ formData.vat_charge }}</div>
                    </div>
                </div>
                <div class="line3">
                    <div class="itemInfo">
                        <div class="itemTitle">美国旺季差额:</div>
                        <div class="itemContent">{{ formData.us_peak_season_balance }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">0利润销售价格:</div>
                        <div class="itemContent">{{ formData.seller_price_no_profit }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">0利润销售价格(免税):</div>
                        <div class="itemContent">{{ formData.seller_price_no_profit_no_tax }}</div>
                    </div>
                </div>
                <div class="line4">
                    <div class="itemInfo">
                        <div class="itemTitle">1-9月仓储费:</div>
                        <div class="itemContent">{{ formData.early_storage_charge }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1-9月利润:</div>
                        <div class="itemContent">{{ formData.early_profit }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1-9月利润(免税):</div>
                        <div class="itemContent">{{ formData.early_profit_no_tax }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1-9月投资回报率:</div>
                        <div class="itemContent">{{
                                formData['early_investment_return_rate'] ? (accMul(formData['early_investment_return_rate'], 100) + '%') : '-'
                            }}
                        </div>
                    </div>
                </div>
                <div class="line4">
                    <div class="itemInfo">
                        <div class="itemTitle">10-12月仓储费:</div>
                        <div class="itemContent">{{ formData.late_storage_charge }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">10-12月利润:</div>
                        <div class="itemContent">{{ formData.late_profit }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">10-12月利润(免税):</div>
                        <div class="itemContent">{{ formData.late_profit_no_tax }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">10-12月投资回报率:</div>
                        <div class="itemContent">{{
                                formData['late_investment_return_rate'] ? (accMul(formData['late_investment_return_rate'], 100) + '%') : '-'
                            }}
                        </div>
                    </div>
                </div>
                <div class="line4">
                    <div class="itemInfo">
                        <div class="itemTitle">利润率(含税):</div>
                        <div class="itemContent">{{formData['profit_rate'] ? accMul(formData['profit_rate'], 100) + '%' : '-' }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">利润率(免税):</div>
                        <div class="itemContent">{{formData['profit_rate_no_tax'] ? accMul(formData['profit_rate_no_tax'], 100) + '%' : '-'}}
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
        <categoryList :visible="showCategoryList" @choose1688Info="choose1688Info" :copyData="copyData"
                      @close-callback="showCategoryList=false"></categoryList>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >关 闭
            </el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm()" :loading="loading">更 新
            </el-button
            >
        </el-row>
        <child-info-modal :visible="childInfoVisible" :info="previewInfo"
                          @close-callback="closeCllback"></child-info-modal>
        <el-dialog title="SKU检测" :visible.sync="skuCheckVisible" width="600px" top="10vh" append-to-body>
            <el-table :data="skuCheckList" border size="mini" max-height="500">
                <el-table-column prop="sku" align="center" label="SKU" min-width="150"></el-table-column>
                <el-table-column prop="name" align="center" label="品名" min-width="150"></el-table-column>
            </el-table>
        </el-dialog>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import categoryList from './categoryList'
import childInfoModal from './childInfoModal.vue'

export default {
    components: {categoryList, childInfoModal},
    data() {
        return {
            selectionPrincipleList:[],
            standardProductTypeArr: [
                {name: '标品-大众', value: '标品-大众'},
                {name: '标品-小众', value: '标品-小众'},
                {name: '非标-大众', value: '非标-大众'},
                {name: '非标-小众', value: '非标-小众'},
            ],
            loading: false,
            showCategoryList: false,
            options: [],
            rules: {
                keepa_category_id: [
                    {
                        required: true,
                        message: '请选择根类目',
                        trigger: 'blur'
                    },
                ],
            },
            formData: {
                set_deliver_mode: ''
            },
            skuData: {
                sku: '',
                color: '',
                size: '',
                box_quantity: ''
            },
            previewInfo: {},
            childInfoVisible: false,
            skuCheckVisible: false,
            skuCheckList: [],
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        copyData: {
            type: Object,
            default: {}
        },
    },
    watch: {
        copyData: {
            handler(val) {
                if (this.visible) {
                    const tempVal = JSON.parse(JSON.stringify(val))
                    tempVal.refund_rate = this.accMul(tempVal.refund_rate, 100)
                    tempVal.is_seasonality = tempVal.is_seasonality === 1 ? true : false
                    tempVal.confirm_selling_price = tempVal.confirm_selling_price === 1 ? true : false
                    tempVal.confirm_ali_message = tempVal.confirm_ali_message === 1 ? true : false
                    this.formData = tempVal
                    // this.getSkuByTitle(tempVal.title)
                }
            },
            immediate: true,
            deep: true
        },
    },
    created(){
      this.initFunc()
    },
    methods: {
        initFunc(){
            api.cost_analysis_selfbuild_get_selection_principle().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.selectionPrincipleList = (res.data || []).map(item=>{
                        return {name: item, value: item}
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        // 根据标题获取SKU数据
        getSkuByTitle(title) {
            if (!title) {
                return
            }
            api.cost_analysis_personal_get_sku_by_title({ title }).then(res => {
                if (res.code === 0 && res.data) {
                    const firstItem = res.data
                    this.$set(this.formData, 'sku', firstItem.sku || '')
                    this.$set(this.formData, 'color', firstItem.color || '')
                    this.$set(this.formData, 'size', firstItem.sile || '')
                    this.$set(this.formData, 'box_quantity', firstItem.box_quantity || '')
                }
            }).catch(() => {
            })
        },
        // SKU检测
        checkSku() {
            if (!this.formData.sku) {
                this.$message({ type: 'warning', message: '请先填写SKU' })
                return
            }
            api.cost_analysis_personal_check_sku({ sku: this.formData.sku }).then(res => {
                if (res.code === 0) {
                    this.skuCheckList = res.data || []
                    this.skuCheckVisible = true
                } else {
                    this.$message({ type: 'error', message: res.message })
                }
            }).catch(() => {
            })
        },
        // 关闭弹窗回调
        closeCllback(isShow) {
            this.childInfoVisible = false
            this.previewInfo = {}
            isShow == true && this.getList()
        },
        showInfo(title, info) {
            console.log('==')
            this.previewInfo = {title, info}
            this.childInfoVisible = true
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        choose1688Info(data) {
            this.formData.ali_href_link = data.detail_url
            this.formData.ali_factory_price = data.price
            this.formData.ali_title = data.title
            this.formData.ali_pic_url = data.pic_url
            this.showCategoryList = false
        },
        choose1688() {
            this.showCategoryList = true
        },
        // 保存信息
        submitForm() {
            if(this.formData.is_seasonality && ['', undefined, null].includes(this.formData.season)) {
                this.$message({type: 'error', message: '是季节性，需选择季节'})
                return
            }
            if(!this.formData.is_seasonality && !['', undefined, null].includes(this.formData.season)) {
                this.$message({type: 'error', message: '不是季节性，需清空选择的季节'})
                return
            }
            if(!this.formData.is_seasonality) {
                this.formData.season = ''
            }
            this.$refs['formData'].validate(valid => {
                if (valid) {
                    api.cost_analysis_personal_personal_operation({
                        id: this.formData.id,
                        title: this.formData.title,
                        ali_href_link: this.formData.ali_href_link,
                        ali_factory_price: this.formData.ali_factory_price,
                        ali_pic_url: this.formData.ali_pic_url,
                        ali_title: this.formData.ali_title,
                        refund_rate: this.accDiv(this.formData.refund_rate, 100),
                        is_seasonality: this.formData.is_seasonality ? 1 : 0,
                        confirm_selling_price: this.formData.confirm_selling_price ? 1 : 0,
                        confirm_ali_message: this.formData.confirm_ali_message ? 1 : 0,
                        long: this.formData.long,
                        wide: this.formData.wide,
                        height: this.formData.height,
                        weight: this.formData.weight,
                        selling_price: this.formData.selling_price,
                        set_deliver_mode: this.formData.set_deliver_mode,
                        selection_principle: this.formData.selection_principle,
                        standard_product_type: this.formData.standard_product_type,
                        season: this.formData.season,
                        sku: this.formData.sku,
                        color: this.formData.color,
                        size: this.formData.size,
                        box_quantity: this.formData.box_quantity,
                    }).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message({message: '修改成功', type: 'success'})
                            const tempVal = JSON.parse(JSON.stringify(res.data))
                            tempVal.refund_rate = this.accMul(tempVal.refund_rate, 100)
                            tempVal.is_seasonality = tempVal.is_seasonality === 1 ? true : false
                            tempVal.confirm_selling_price = tempVal.confirm_selling_price === 1 ? true : false
                            tempVal.confirm_ali_message = tempVal.confirm_ali_message === 1 ? true : false
                            this.$set(this, 'formData', tempVal)
                            this.$emit('refreshList')
                            // 更新SKU数据
                            if (res.data.sku !== undefined || res.data.color !== undefined || res.data.size !== undefined || res.data.box_quantity !== undefined) {
                                this.skuData = {
                                    sku: res.data.sku || '',
                                    color: res.data.color || '',
                                    size: res.data.size || '',
                                    box_quantity: res.data.box_quantity || ''
                                }
                            }
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(() => {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '网络出现问题，请刷新页面！'
                        })
                    })
                } else {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '请填写相应内容！'
                    })
                }
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.formData = {}
            this.$refs['formData'].resetFields()
            this.loading = false
            this.$emit('close-callback', isshow)
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },

        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },

        accDiv(arg1, arg2) {
            let t1, t2
            t1 = this.getDecimalLength(arg1)
            t2 = this.getDecimalLength(arg2)
            if (t1 - t2 > 0) {
                return (this.getNum(arg1) / this.getNum(arg2)) / Math.pow(10, t1 - t2)
            } else {
                return (this.getNum(arg1) / this.getNum(arg2)) * Math.pow(10, t2 - t1)
            }
        },

        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.subTitle {
    font-size: 16px;
    font-weight: 900;
    margin: 20px 0;
}

.sku-data-form-item {
    .el-form-item__content {
        display: flex;
        gap: 10px;
    }

    .sku-item {
        display: flex;
        gap: 10px;

        .el-form-item {
            margin-bottom: 0;
        }
    }
}

.top1 {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .top1Right {
        display: flex;
        flex-wrap: wrap;
        width: 1200px;

        .itemInfo {
            width: 360px;
            display: flex;
            height: 28px;
            line-height: 28px;

            .itemTitle {
                font-size: 14px;
                color: #606266;
                padding: 0 12px 0 0;
                font-weight: 900;
            }

            .itemContent {
                width: 230px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}

.top3 {
    display: flex;
    justify-content: space-between;
    width: 600px;

    .top3Left {
        width: 100px;
        height: 120px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        button {
            margin-top: 10px;
        }
    }

    .top3Right {
        width: 400px;

    }
}

.top4 {
    .line1, .line2, .line4, .line3 {
        display: flex;
        justify-content: start;
    }

    .itemInfo {
        width: 25%;
        display: flex;
        height: 28px;
        line-height: 28px;
        margin-bottom: 10px;

        .itemTitle {
            font-size: 14px;
            color: #606266;
            padding: 0 12px 0 0;
            font-weight: 900;
        }

        .itemContent {
            max-width: 230px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .line4 {
        .line4Left, .line4Right {
            width: 50%;
        }

        .itemInfo {
            width: 100%;
        }
    }

}

.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
